/**
 * ModalContent.jsx
 *
 * @Author: jruif
 * @Date: 2017/7/7 下午10:02
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
/**
 * @ignore
 * */
const ModalContent = ({ prefixCls, className, children }) => {
  const classes = classNames(`${prefixCls}-content`, className);
  return <div className={classes}>{children}</div>;
};

ModalContent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

ModalContent.defaultProps = {
  prefixCls: 'ne-modal',
};

export default ModalContent;



// WEBPACK FOOTER //
// ./src/modal/ModalContent.jsx